// Veux types
import * as StoreCommonTypes from '../store/types/common'

const resetStore = {
  data () {
    return {
      storeModules: [
        'apps',
        'training',
        'user'
      ]
    }
  },
  methods: {
    resetAllStoreModules: function () {
      // Call reset for each module
      this.storeModules.forEach((module) => {
        this.$store.dispatch(`${module}/${StoreCommonTypes.ACTION_RESET_STATE}`)
      })
    }
  }
}

export default resetStore
//
